import z from "zod";

import { candidateFileIdSchema } from "@/types/candidateFile";

export const FileSchema = z.object({
  name: z.string(),
  url: z.string(),
});

export const UploadedFileSchema = FileSchema.extend({
  fileId: candidateFileIdSchema,
});
export type UploadedFile = z.infer<typeof UploadedFileSchema>;
